export default "__VITE_ASSET__tLe8iMs3__"